import { lazy } from 'react';

export const CloudGovernanceDashboard = lazy(() =>
  import('@/capabilities/cloud-governance/pages/CloudGovernanceDashboard').then((m) => ({
    default: m.CloudGovernanceDashboard,
  }))
);

export const RateLimitsPage = lazy(() =>
  import('@/capabilities/cloud-governance/pages/RateLimitsPage').then((m) => ({
    default: m.RateLimitsPage,
  }))
);

export const RecordsroomOperationsPage = lazy(() =>
  import('@/capabilities/cloud-governance/pages/RecordsroomOperationsPage').then((m) => ({
    default: m.RecordsroomOperationsPage,
  }))
);
